import { useContext, useRef, useEffect, useCallback } from 'react';
import ddt from '@wix/da-ddt';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
var logger = ddt.createLogger('comments');
export function useScrollToLatestComment(lastInsertedCommentId) {
    var isMobile = useContext(MobileContext);
    var needsToScroll = useRef(false);
    var lastCommentElement = useRef();
    var previousLastCommentId = useRef(lastInsertedCommentId);
    useEffect(function () {
        if (!needsToScroll.current &&
            (!lastInsertedCommentId ||
                lastInsertedCommentId === previousLastCommentId.current)) {
            return;
        }
        previousLastCommentId.current = lastInsertedCommentId;
        if (!lastCommentElement.current) {
            needsToScroll.current = true;
            return;
        }
        needsToScroll.current = false;
        logger.log('Scrolling to latest comment');
        scrollIntoViewWithHeader(lastCommentElement.current, isMobile);
    }, [lastInsertedCommentId, isMobile]);
    var setLastComment = useCallback(function (element) {
        lastCommentElement.current = element;
    }, []);
    return { setLastComment: setLastComment };
}
//# sourceMappingURL=useScrollToLatestComment.js.map